import React from 'react';
import styled from 'styled-components';
import { FONTS, COLORS } from "../utils/styleConstants";

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(17, 16, 60, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const PopupContainer = styled.div`
  background: linear-gradient(90deg, rgb(255, 199, 181) 0%, #ffe4d6 25%, #f5f9ff 75%, rgb(219, 237, 251) 100%);
  border-radius: 15rem;
  padding: 2.5rem 6rem;
  max-width: 800px;
  width: 90%;
  min-height: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 2rem 2.5rem;
    max-width: 600px;
    width: 95%;
    min-height: 350px;
    border-radius: 15rem;
  }
  
  @media (max-width: 480px) {
    padding: 1.5rem 1.5rem;
    max-width: 350px;
    width: 95%;
    min-height: 300px;
    border-radius: 15rem;
  }
`;

const PopupTitle = styled.h2`
  color: ${COLORS.SECONDARY};
  font-family: 'WorkSans', sans-serif;
  font-size: 2.25rem;
  font-weight: 300;
  margin: 0 0 1rem 0;
  text-align: center;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    line-height: 2.2rem;
    margin-bottom: 1rem;
    max-width: 350px;
  }
  
  @media (max-width: 480px) {
    font-size: 1.25rem;
    line-height: 1.4rem;
    margin-bottom: 0.75rem;
    max-width: 280px;
  }
`;

const PopupMessage = styled.p`
  color: ${COLORS.SECONDARY};
  font-family: 'WorkSans', sans-serif;
  font-size: 1.rem;
  font-weight: 400;
  text-align: center;
  margin: 0 0 1.5rem 0;
  max-width: 550px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.4rem;
    margin-bottom: 1.5rem;
    max-width: 320px;
  }
  
  @media (max-width: 480px) {
    font-size: 0.85rem;
    line-height: 1.2rem;
    margin-bottom: 1.25rem;
    max-width: 260px;
  }
`;

const PopupOfferInfo = styled.div`
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 1rem;
  padding: 1.5rem;
  margin: 1.5rem auto;
  max-width: 400px;
  backdrop-filter: blur(10px);

  h4 {
    margin: 0 0 1rem 0;
    font-size: 1rem;
    color: ${COLORS.SECONDARY};
    font-family: 'WorkSans', sans-serif;
    font-weight: 500;
    text-align: center;
  }

  p {
    margin: 0.5rem 0;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY};
    font-family: 'WorkSans', sans-serif;
    text-align: center;
  }
  
  @media (max-width: 768px) {
    padding: 1.25rem;
    margin: 1.25rem auto;
    max-width: 350px;
    
    h4 {
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
    }
    
    p {
      font-size: 0.8rem;
    }
  }
  
  @media (max-width: 480px) {
    padding: 1rem;
    margin: 1rem auto;
    max-width: 280px;
    
    h4 {
      font-size: 0.8rem;
      margin-bottom: 0.5rem;
    }
    
    p {
      font-size: 0.75rem;
    }
  }
`;

const PopupActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const PopupButton = styled.button`
  background-color: transparent;
  color: ${COLORS.ACCENT};
  border: 1px solid ${COLORS.ACCENT};
  border-radius: 2rem;
  padding: 0.625rem 1.75rem;
  font-family: 'WorkSans', sans-serif;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;

  &:hover {
    background-color: ${COLORS.ACCENT};
    color: white;
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 112, 87, 0.3);
  }
  
  @media (max-width: 768px) {
    padding: 0.5rem 1.5rem;
    font-size: 0.85rem;
    min-width: 100px;
  }
  
  @media (max-width: 480px) {
    padding: 0.35rem 1rem;
    font-size: 0.75rem;
    min-width: 70px;
  }
`;

const OfferPopup = ({ isOpen, onClose, popupMessage, offerInfo }) => {
  if (!isOpen) return null;

  return (
    <PopupOverlay onClick={onClose}>
      <PopupContainer onClick={(e) => e.stopPropagation()}>
        <PopupTitle>{popupMessage?.title}</PopupTitle>
        
        <PopupMessage dangerouslySetInnerHTML={{ __html: popupMessage?.message }} />
        
        <PopupActions>
          <PopupButton onClick={onClose}>
            Iniciar
          </PopupButton>
        </PopupActions>
      </PopupContainer>
    </PopupOverlay>
  );
};

export default OfferPopup; 